import { fetchRequestDinamica } from "@providers/conect_prev";
import { fetchRequest } from "@providers/conect";

const cancelarCitaPromoCostaApi = async ( data ) => {
  try {
    const url = `apiPromoCita/api/CM/CMAutoGestionCitas/DG_CancelarCita`
    const response = await fetchRequestDinamica(url, {
      method: "POST",
      token: 'Q0lUQTpDeXBhZzIwMjArKw==',
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const cancelarCitaPromoNorteApi = async ( data ) => {
  try {
    const url = `apiSalsocCita/api/CM/CMAutoGestionCitas/DG_CancelarCita`
    const response = await fetchRequestDinamica(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const cancelarCitaCalidadMedicaApi = async ( data ) => {
  try {
    const url = `apiCalMedCita/api/CM/CMAutoGestionCitas/DG_CancelarCita`
    const response = await fetchRequestDinamica(url, {
      method: "POST",
      token: 'Q0lUQTpDeXBhZzIwMjArKw==',
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const cancelarCitaLocalApi = async (data) => {
  try {
    const url = `agendawp/cancelar-cita`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: {
        ...data,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { cancelarCitaPromoCostaApi, cancelarCitaPromoNorteApi, cancelarCitaCalidadMedicaApi, cancelarCitaLocalApi   };
